let libs = {};

function LoadExternalLibrary({ name, url } = {}) {
  console.info(`LoadExternalLibrary :: Loading ${name} from ${url}`);

  if (name && window[name]) {
    return Promise.resolve(window[name]);
  }

  let existing = libs.url;
  if (existing) {
    return existing;
  }

  let p = new Promise((resolve, reject) => {
    let s = document.createElement('script');
    s.src = url;
    s.addEventListener('load', function() {
      if (name && window[name]) {
        resolve(window[name]);
        return;
      } else if (name && !window[name]) {
        reject(`Unable to load ${name} library from ${url}`);
        return;
      }

      resolve();
    });

    if (document.head instanceof HTMLElement) {
      document.head.appendChild(s);
    }
  });

  libs.url = p;
  return p;
}

export default LoadExternalLibrary;



// WEBPACK FOOTER //
// ./src/javascripts/toolkit/LoadExternalLibrary.js